import PropTypes from 'prop-types';
import React from 'react';

import classnames from 'classnames';

import Store from '@app/store';
import Actions from '@app/store/action';

// We'll probably make this toggle so the default links won't work.
import MobileItem from '@component/navigation/mobileitem';

export default class MobileNavigation extends React.Component {
  static propTypes = {
    route: PropTypes.object,
    menuItems: PropTypes.array,
    style: PropTypes.object,
  };

  /**
   * Binds all private methods
   * @param  {Object} props Component props
   */
  constructor(props) {
    super(props);

    this.state = {
      activeMenuIndex: null,
      animateSubNav: true,
    };

    this.closeMenu = this.closeMenu.bind(this);
    this.onNavigation = this.onNavigation.bind(this);
    this.onGlobalClick = this.onGlobalClick.bind(this);
  }

  onClick(index) {
    let activeMenuIndex = null,
      animateSubNav = true;

    // opening for the first time
    if (this.state.activeMenuIndex === null) {
      activeMenuIndex = index;
      animateSubNav = true;
    } else if (this.state.activeMenuIndex !== index) {
      // opening another menu
      activeMenuIndex = index;
      animateSubNav = false;
    }

    this.setState({
      activeMenuIndex: activeMenuIndex,
      animateSubNav: animateSubNav,
    });
  }

  onNavigation(path) {
    if (path === '/signout') {
      Store.dispatch(Actions.User.signout());
      return;
    }

    this.closeMenu();
  }

  onGlobalClick(e) {
    if (this.state.activeMenuIndex === null) {
      return;
    }
    if (e.target === this.node || this.node.contains(e.target)) {
      return;
    }

    this.closeMenu();
  }

  closeMenu() {
    if (this.state.activeMenuIndex === null) {
      return;
    }

    this.setState({ activeMenuIndex: null, animateSubNav: true });
  }

  componentDidMount() {
    window.addEventListener('touchstart', this.onGlobalClick, true);
    window.addEventListener('scroll', this.closeMenu);
  }

  componentWillUnmount() {
    window.removeEventListener('touchstart', this.onGlobalClick, true);
    window.removeEventListener('scroll', this.closeMenu);
  }

  render() {
    const path = this.props.route.path;
    const className = classnames('nav', {
      'nav--home': path === '/',
      'nav--plus': path === '/pro',
    });
    const menuItems = [];

    // Render all of our items
    this.props.menuItems.forEach((menuItem, i) => {
      // Figure out if this is the child which needs to render the subnav
      let showSubNav = false;
      if (this.state.activeMenuIndex === i) {
        showSubNav = true;
      }

      menuItems.push(
        <MobileItem
          key={`mobile-menu-item-${menuItem.id}`}
          className="nav__item"
          onItemClick={this.onNavigation}
          onClick={this.onClick.bind(this, i)}
          showSubNav={showSubNav}
          animateSubNav={this.state.animateSubNav}
          {...menuItem}
        />
      );
    });

    const nav = <ul className="nav__items">{menuItems}</ul>;

    return (
      <nav ref={(node) => (this.node = node)} className={className}>
        {nav}
      </nav>
    );
  }
}
